"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
var $a3a4bece0086b835$exports = {};
"use strict";
class $a3a4bece0086b835$var$Tile {
    constructor(position, value){
        this.x = position.x;
        this.y = position.y;
        this.value = value || 2;
        this.previousPosition = null;
        this.mergedFrom = null;
        this.id = $a3a4bece0086b835$var$Tile.idCounter++;
    }
    savePosition() {
        this.previousPosition = {
            x: this.x,
            y: this.y
        };
    }
    updatePosition(position) {
        this.x = position.x;
        this.y = position.y;
    }
    serialize() {
        return {
            position: {
                x: this.x,
                y: this.y
            },
            value: this.value,
            mergedFrom: this.mergedFrom ? this.mergedFrom.map((t)=>t.serialize()) : null,
            id: this.id
        };
    }
}
$a3a4bece0086b835$var$Tile.idCounter = 0;
$a3a4bece0086b835$exports = $a3a4bece0086b835$var$Tile;


class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.board = Array(this.size).fill(null).map(()=>Array(this.size).fill(null));
        if (initialState) {
            this.score = initialState.score;
            this.status = initialState.status;
            initialState.board.forEach((row, y)=>{
                row.forEach((value, x)=>{
                    if (value !== 0) this.board[y][x] = new $a3a4bece0086b835$exports({
                        x: x,
                        y: y
                    }, value);
                });
            });
        } else {
            this.addRandomTile();
            this.addRandomTile();
        }
    }
    prepareTiles() {
        this.board.flat().forEach((tile)=>{
            if (tile) {
                tile.mergedFrom = null;
                tile.savePosition();
            }
        });
    }
    syncTilePositions() {
        this.board.forEach((row, y)=>{
            row.forEach((tile, x)=>{
                if (tile) tile.updatePosition({
                    x: x,
                    y: y
                });
            });
        });
    }
    shiftLeft() {
        let moved = false;
        for(let y = 0; y < this.size; y++){
            let row = this.board[y].filter((tile)=>tile !== null);
            for(let i = 0; i < row.length - 1; i++){
                if (row[i] === null) continue;
                if (row[i].value === row[i + 1].value) {
                    const tile1 = row[i];
                    const tile2 = row[i + 1];
                    const val = tile1.value * 2;
                    this.score += val;
                    if (val === 2048) this.status = "won";
                    const merged = new $a3a4bece0086b835$exports({
                        x: -1,
                        y: -1
                    }, val);
                    merged.mergedFrom = [
                        tile1,
                        tile2
                    ];
                    row[i] = merged;
                    row[i + 1] = null;
                }
            }
            row = row.filter((tile)=>tile !== null);
            while(row.length < this.size)row.push(null);
            if (this.arraysEqual(this.board[y], row) === false) {
                moved = true;
                this.board[y] = row;
            }
        }
        return moved;
    }
    afterMove() {
        this.syncTilePositions();
        this.addRandomTile();
        if (this.canMove() === false) this.status = "lost";
    }
    moveLeft() {
        this.prepareTiles();
        const moved = this.shiftLeft();
        if (moved) this.afterMove();
    }
    moveRight() {
        this.prepareTiles();
        this.reverseRows();
        const moved = this.shiftLeft();
        this.reverseRows();
        if (moved) this.afterMove();
    }
    moveUp() {
        this.prepareTiles();
        this.transpose();
        const moved = this.shiftLeft();
        this.transpose();
        if (moved) this.afterMove();
    }
    moveDown() {
        this.prepareTiles();
        this.transpose();
        this.reverseRows();
        const moved = this.shiftLeft();
        this.reverseRows();
        this.transpose();
        if (moved) this.afterMove();
    }
    getScore() {
        return this.score;
    }
    getState() {
        return {
            board: this.board.map((row)=>row.map((tile)=>tile ? tile.value : 0)),
            score: this.score,
            status: this.status,
            tiles: this.board.flat().filter((tile)=>tile !== null).map((tile)=>tile.serialize())
        };
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.restart();
    }
    restart() {
        this.board = Array(this.size).fill(null).map(()=>Array(this.size).fill(null));
        this.score = 0;
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    addRandomTile() {
        const emptyCells = [];
        for(let y = 0; y < this.size; y++){
            for(let x = 0; x < this.size; x++)if (this.board[y][x] === null) emptyCells.push({
                x: x,
                y: y
            });
        }
        if (emptyCells.length === 0) return;
        const { x: randX, y: randY } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        this.board[randY][randX] = new $a3a4bece0086b835$exports({
            x: randX,
            y: randY
        }, Math.random() < 0.1 ? 4 : 2);
    }
    arraysEqual(a, b) {
        return a.length === b.length && a.every((val, index)=>val === b[index]);
    }
    canMove() {
        for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
            const val = this.board[y][x];
            if (val === null) return true;
            if (x < this.size - 1) {
                const right = this.board[y][x + 1];
                if (right && val.value === right.value) return true;
            }
            if (y < this.size - 1) {
                const down = this.board[y + 1][x];
                if (down && val.value === down.value) return true;
            }
        }
        return false;
    }
    reverseRows() {
        for (const row of this.board)row.reverse();
    }
    transpose() {
        const newBoard = Array(this.size).fill(null).map(()=>Array(this.size).fill(null));
        for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++)newBoard[x][y] = this.board[y][x];
        this.board = newBoard;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button.start");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$tileContainer = document.querySelector(".tile-container");
const $09e991522ca7e64e$var$tilesMap = new Map();
function $09e991522ca7e64e$var$getTilePosition(x, y) {
    return {
        top: `${10 + y * 110}px`,
        left: `${10 + x * 110}px`
    };
}
function $09e991522ca7e64e$var$createTileElement(tile) {
    const el = document.createElement("div");
    el.classList.add("tile");
    el.classList.add(`tile--${tile.value}`);
    el.textContent = tile.value;
    const pos = $09e991522ca7e64e$var$getTilePosition(tile.position.x, tile.position.y);
    el.style.top = pos.top;
    el.style.left = pos.left;
    return el;
}
function $09e991522ca7e64e$var$renderBoard(state) {
    $09e991522ca7e64e$var$scoreElement.textContent = state.score;
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    if (state.status === "won") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    if (state.status === "lost") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    const activeIds = new Set();
    state.tiles.forEach((tile)=>{
        activeIds.add(tile.id);
        if (tile.mergedFrom) tile.mergedFrom.forEach((parent)=>{
            if ($09e991522ca7e64e$var$tilesMap.has(parent.id)) {
                const parentEl = $09e991522ca7e64e$var$tilesMap.get(parent.id);
                $09e991522ca7e64e$var$tilesMap.delete(parent.id);
                const pos = $09e991522ca7e64e$var$getTilePosition(tile.position.x, tile.position.y);
                parentEl.style.top = pos.top;
                parentEl.style.left = pos.left;
                parentEl.style.zIndex = "10";
                setTimeout(()=>{
                    parentEl.remove();
                }, 200);
            }
        });
        let el = $09e991522ca7e64e$var$tilesMap.get(tile.id);
        const pos = $09e991522ca7e64e$var$getTilePosition(tile.position.x, tile.position.y);
        if (!el) {
            el = $09e991522ca7e64e$var$createTileElement(tile);
            $09e991522ca7e64e$var$tileContainer.appendChild(el);
            $09e991522ca7e64e$var$tilesMap.set(tile.id, el);
            if (tile.mergedFrom) el.classList.add("tile-merged");
            else el.classList.add("tile-new");
        } else {
            el.style.top = pos.top;
            el.style.left = pos.left;
            if (el.textContent !== tile.value) {
                el.textContent = tile.value;
                el.className = `tile tile--${tile.value}`;
                el.classList.add("tile-merged");
            }
        }
    });
    const idsToRemove = [];
    $09e991522ca7e64e$var$tilesMap.forEach((_, id)=>{
        if (!activeIds.has(id)) idsToRemove.push(id);
    });
    idsToRemove.forEach((id)=>{
        $09e991522ca7e64e$var$tilesMap.get(id).remove();
        $09e991522ca7e64e$var$tilesMap.delete(id);
    });
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$tileContainer.innerHTML = "";
    $09e991522ca7e64e$var$tilesMap.clear();
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$startButton.textContent = "Restart";
    $09e991522ca7e64e$var$startButton.classList.remove("start");
    $09e991522ca7e64e$var$startButton.classList.add("restart");
    $09e991522ca7e64e$var$renderBoard($09e991522ca7e64e$var$game.getState());
});
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$renderBoard($09e991522ca7e64e$var$game.getState());
});


//# sourceMappingURL=index.af31571c.js.map
